import { getCurrentInstance } from "vue";

export function useI18n() {
  const vm = getCurrentInstance();

  if (!vm) {
    throw new Error('"useStore" must be called in setup');
  }

  return vm.proxy.$i18n;
}
